<template>
  <div class="g-nav">
    <div class="g-nav-site">
    </div>
    <div>
      <div class="g-nav-row">
        <div class="g-nav-content">
          <div
            class="nav-item"
            v-for="(item, index) in routerArr"
            :key="'routerArr-' + index"
            :class="{active: index === activeIndex || (item.name === '产品分类' && $route.path === '/home')}"
            @click="linkToRouter(item,index);"
          >
          <template v-if="item.name !== '产品分类' && item.name !== '宝舰开店' && item.name !== '学术交流' && item.name !== 'CMEF头条' && item.name !== '品牌展会'">
            {{item.name}}
          </template>
          <template v-if="item.name === '宝舰开店'">
            {{item.name}}
            <div class="act-list">
              <div class="act-list-tab" @click="linkEnter">厂商-我要入驻</div>
              <div class="act-list-tab" @click="linkJoin">代理商-加盟</div>
            </div>
          </template>
          <template v-if="item.name === '学术交流'">
            {{item.name}}
            <div class="act-list" style="width:170px;">

              <div class="act-list-tab tab-visitor" @click="linkcmef">
                CMEF Live
<!--                <i class="icon iconfont icon-xiala"></i>-->
<!--                <div class="visitor">-->
<!--                  <p @click="linkYL">云课</p>-->
<!--                  <p @click="linkYM">云会议</p>-->
<!--                  <p @click="linkMetting">线下论坛</p>-->
<!--                </div>-->
              </div>
              <div class="act-list-tab" @click="linkMeetinglive">会议直播</div>

              <div class="act-list-tab" @click="linkMetting">线下论坛</div>
              <div class="act-list-tab" @click="linkguoji">国际直播</div>
              <div class="act-list-tab" @click="linkM">新品马拉松@上海</div>
              <div class="act-list-tab" @click="$router.push('/act-list')">活动集</div>
            </div>
          </template>
          <template v-if="item.name === '产品分类'">
            {{item.name}}
            <div class="act-list pro-list" :style="($router.history.current.path === '/home')?'display:block':''" v-if="categoryList && categoryList.length">
              <div
                class="act-list-tab"
                v-for="(itm,idx) in categoryList"
                :key="idx"
                :class="itm.list && itm.list.length?'tab-visitor':''"
                v-if="idx < 8"
              >
                <p :title="itm.name">{{itm.name}}</p>
                <i v-if="itm.list && itm.list.length" class="icon iconfont icon-xiala"></i>
                <div class="visitor">
                  <div class="visitor-two" v-for="(im,ix) in itm.list" :key="ix" :title="im.name" v-if="ix < 10">
                    <p :title="im.name">{{im.name}}</p>
                    <i v-if="im.list && im.list.length" class="icon iconfont icon-xiala"></i>
                    <div class="visitor-three" v-if="im.list && im.list.length">
                      <p @click="searchThree(m)" v-for="(m,x) in im.list" :key="x" :title="m.name" v-if="x < 10">{{m.name}}</p>
                    </div>
                  </div>
                  <div v-if="itm.list.length > 10" class="visitor-two" style="text-align:center;" @click="linkToMore()">更多</div>
                </div>
              </div>
              <div v-if="categoryList.length > 10" class="act-list-tab more" @click="linkToMore()">更多</div>
            </div>
          </template>
          <template v-if="item.name === 'CMEF头条'">
            {{item.name}}
            <div class="act-list">
              <div class="act-list-tab" style="text-align:center;padding-left:0;" @click="linkToNews(0)">行业动态</div>
              <div class="act-list-tab" style="text-align:center;padding-left:0;" @click="linkToNews(1)">企业动态</div>
            </div>
          </template>
          <template v-if="item.name === '品牌展会'">
            {{item.name}}
            <div class="act-list">
              <div class="act-list-tab" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;padding-right:20px;" @click="linkToPlan(pim)" v-for="(pim,pdx) in planList" :key="pdx">{{pim.shortName}}</div>
            </div>
          </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "g-nav",
  data() {
    return {
      activeIndex: 0,
      routerArr: [
        { name: "产品分类" },
        { name: "首页", router: "/home" },
        {
          name: "产品&企业",
          router: "/ex-list",
          children: [
            { name: "展商详情", router: "/ex-details/" },
            { name: "产品详情", router: "/pro-details/" }
          ]
        },
        // {
        //   name: "新品马拉松",
        //   router: "/act-list",
        //   children: [{ name: "活动详情", router: "/activity-details/" }]
        // },
        {
          name: "供需对接",
          router: "/chance",
          children: [{ name: "商机详情", router: "/chance-detail" }]
        },
        { name: "宝舰开店" },
        { name: "学术交流" },
        // { name: "CMEF云课", router: "/home2" },
        // { name: "联系我们", router: "/contact" },
        { name: "CMEF头条" },
        { name: "品牌展会" }
      ],
      site: "首页",
      categoryList: [],
      caDisplay: true,
      planList: []
    };
  },
  watch: {
    $route(to, from) {
      this.setIndex();
    }
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId',
    })
  },
  created() {
    let categoryList = JSON.parse(sessionStorage.getItem('categoryList'));
    if (categoryList && categoryList.length) {
      this.categoryList = categoryList;
    } else {
      this.getCategory();
    }
    this.setIndex();
    this.getPlan();
  },
  methods: {
    ...mapMutations({
      setCaId: "exhibitor/setCaId"
    }),
    ...mapActions({
      getProductCategory: "exhibitor/getProductCategory",
      getExhibitionPlan: "exhibitor/getExhibitionPlan",
    }),
    setIndex() {
      const path = this.$route.path;
      // const path = this.$router.history.current.path;
      this.routerArr.some((el, idx) => {
        // console.log(path,el,idx)
        if (el.router && path.search(el.router) !== -1) {
          this.activeIndex = idx;
          this.site = el.name;
        }

        if (el.children && el.children.length) {
          el.children.forEach(c => {
            if (path.indexOf(c.router) !== -1) {
              this.activeIndex = idx;
              this.site = c.name;
            }
          });
        }

        if (path === "/act-list" || path.indexOf("/activity-details") !== -1) {
          this.activeIndex = 5;
        }
        if (path === "/about") {
          this.activeIndex = idx;
        }
        if (path === "/news" || path === "/news-details") {
          this.activeIndex = 6;
        }
        if (path === "/contact") {
          this.activeIndex = 7;
        }
      });
      if (path === "/home2") {
        this.activeIndex = 1;
        this.$router.push("/home");
        this.site = "首页";
      }
    },
    async getPlan() {
      let list = await this.getExhibitionPlan();
      if (list && list.length > 0) {
        this.planList = list;
      } else {
        this.planList = [];
      }
      this.planList.push({
        shortName: "联系我们"
      });
    },
    linkToRouter(item,index) {
      if (item.router) {
        this.activeIndex = index;
        this.$router.push(item.router);
        if (item.router === "/home2") {
          this.activeIndex = 0;
          this.$router.push("/home");
          this.site = "首页";
        } 
      }
    },
    linkcmef(){
      window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/alive/l_5f6c6c62e4b01b26d1bc280e?type=2")
    },
    linkguoji(){
      window.open("https://app3lxzcngw9132.h5.xiaoeknow.com/v1/course/column/p_5f589688e4b0c551037529af?type=3")
    },
    async getCategory() {
      let list = await this.getProductCategory(this.exhibitionId);
      if (list && list.length) {
        this.categoryList = list;
        sessionStorage.setItem('categoryList', JSON.stringify(this.categoryList));
      }
      // console.log("分类列表：",this.categoryList);
    },
    linkToMore() {
      // if (this.$route.fullPath === '/ex-list') {
      //   return;
      // }
      // this.caDisplay = false;
      // this.$router.push("/ex-list");

      // 修改：
      const url = location.origin + "/ex-list";
      window.open(url,"_blank");
    },
    searchThree(e) {
      // if (this.$route.fullPath === '/ex-list') {
      //   this.caDisplay = false;
      //   this.setCaId(e.id);
      //   setTimeout(() => {
      //     this.caDisplay = true;
      //   },100)
      //   return;
      // }
      // this.caDisplay = false;
      // this.setCaId(e.id);
      // this.$router.push("/ex-list");

      // 修改：
      const url = location.origin + "/ex-list?id=" + e.id + "&" + e.name;
      window.open(url,"_blank");
    },

    linkToPlan(e) {
      if (e.shortName === "联系我们") {
        this.$router.push("/contact");
      } else {
        this.$router.push("/about?id=" + e.id + "&name=" + e.name);
      }
    },
    linkToNews(e) {
      this.$router.push("/news?type=" + e);
    },
    linkMetting() {
      this.$router.push("/meeting");
    },
    linkEnter() {
      window.open('http://ruzhu.jzzchina.com/#/businessJoin','_blank');
    },
    linkJoin() {
      window.open('http://ruzhu.jzzchina.com/#/agentJoin','_blank');
    },
    linkM() {
      window.open('https://marathon.cmef.com.cn/','_blank');
    },
    linkYL() {
      window.open('https://live.cmef.com.cn/page/945270','_blank');
    },
    linkYM() {
      window.open('https://live.cmef.com.cn/all/2152522','_blank');
    },
    linkMeetinglive() {
      this.$router.push("/meeting-live");
    }
  },
};
</script>

<style lang="scss" scoped>
.g-nav {
  width: 100%;
  height: 82px;
  background-color: #fff;
  color: #000;
  &-row {
    height: 42px;
    width: 1200px;
    margin: 0 auto;
  }
  &-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .nav-item {
    font-size: 16px;
    width: 172px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    position: relative;
    .act-list {
      display: none;
      width: 100%;
      top: 42px;
      left: 0;
      position: absolute;
      z-index: 100;
      .more {
        padding-left: 0;
        text-align: center;
      }
      &-tab {
        background-color: rgba(2,76,139,0.75);
        width: 100%;
        // height: 42px;
        text-align: left;
        padding-left: 20px;
        position: relative;
        border-bottom: 1px solid #0059a4;
        p {
          width: calc(100% - 42px);
          // overflow: hidden;
          // text-overflow:ellipsis;
          // white-space: nowrap;
          word-break: break-all;
          line-height: 1.5;
          padding: 10px 0;
        }
        i {
          position: absolute;
          top: 0;
          right: 20px;
          display: inline-block;
          transform: rotate(-90deg);
        }
        &:hover {
          opacity: 1;
          background-color: #fff;
          color: #b1262d;
        }
        .visitor {
          display: none;
          color: #fff;
          width: 100%;
          position: absolute;
          top: 0;
          right: -100%;
          height: auto;
          p {
            // height: 42px;
            background-color: rgba(2,76,139,0.75);
            padding-left: 20px;
            // border-bottom: 1px solid #0059a4;
            &:hover {
              opacity: 1;
              background-color: #fff;
              color: #b1262d;
            }
          }
          .visitor-two {
            width: 100%;
            // height: 42px;
            background-color: rgba(2,76,139,0.75);
            border-bottom: 1px solid #0059a4;
            position: relative;
            p {
              width: calc(100% - 42px);
              // height: 42px;
              padding-left: 20px;
              background-color: transparent;
            }
            &:hover {
              opacity: 1;
              background-color: #fff;
              color: #b1262d;
              .visitor-three {
                display: block;
              }
            }
          }
          .visitor-three {
            color: #fff;
            width: 100%;
            display: none;
            position: absolute;
            top: 0;
            right: -100%;
            height: auto;
            p {
              // height: 42px;
              background-color: rgba(2,76,139,0.75);
              padding-left: 20px;
              border-bottom: 1px solid #0059a4;
              &:hover {
                opacity: 1;
                background-color: #fff;
                color: #b1262d;
              }
            }
          }
        }
      }
      .tab-visitor {
        &:hover {
          .visitor {
            display: block;
          }
        }
      }
    }
    .pro-list {
      width: 150%;
      font-size: 14px;
    }
    &.active,
    &:hover {
      background-color: #024c8b;
      color: #fff;
    }
    &:hover {
      .act-list {
        display: block;
      }
    }
  }
  &-site {
    width: 1200px;
    height: 40px;
    margin: 0 auto;
    // display: flex;
    // justify-content: space-between;
    text-align: right;
    .site-l {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      i {
        font-size: 22px;
        color: #024c8b;
      }
    }
    .site-r {
      height: 100%;
      line-height: 40px;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
